








































import Vue, { PropType } from 'vue';
import * as Utils from '@/utils';
import { OrgUser } from '@/models/orgStructure';

import OrganizationUserSlug from '@/components/OrganizationUserSlug.vue';
import { MemberRole } from '@/models';

const parseUsers = (unparsed: string) =>
  Utils.parseByDelimiter(unparsed)
    .filter(email => !!email)
    .map(Utils.trimBrackets)
    .map(raw => ({
      raw,
      normalized: raw.toLowerCase()
    }));

interface CreateStatus {
  email: string;

  valid: boolean;

  // True if the email exists in the blocking users prop.
  blocked: boolean;

  // If the user already exists in either allowed or blocking users
  user?: ExistingUser;
}

type ExistingUser = OrgUser &
  ({ roles: MemberRole[] } | { role: MemberRole } | {});

export default Vue.extend({
  components: {
    OrganizationUserSlug
  },

  props: {
    unparsedUsers: {
      type: String
    },
    blockingUsers: {
      type: Array as PropType<ExistingUser[]>,
      default: (): ExistingUser[] => []
    },
    allowedUsers: {
      type: Array as PropType<ExistingUser[]>,
      default: (): ExistingUser[] => []
    }
  },

  data() {
    return {
      parsed: parseUsers(this.unparsedUsers)
    };
  },

  computed: {
    statuses(): CreateStatus[] {
      return this.parsed.map(({ raw, normalized }) => {
        const blockingUser = this.blockingUsers.find(bu =>
          bu.emails.some(ue => ue.email === normalized)
        );

        const allowedUser = this.allowedUsers.find(au =>
          au.emails.some(ue => ue.email === normalized)
        );

        return {
          email: raw,
          valid: Utils.validateEmail(raw),
          blocked: !!blockingUser,
          user: blockingUser || allowedUser
        };
      });
    },

    // Either an existing user or the email of a new user
    readyUsers(): (OrgUser | string)[] {
      return this.statuses
        .filter(cs => cs.valid && !cs.blocked)
        .map(cs => (cs.user ? cs.user : cs.email));
    }
  },

  methods: {
    close() {
      this.$emit('close');
    }
  },

  watch: {
    unparsedUsers(value: string) {
      this.parsed = parseUsers(value);
    }
  }
});
